import React, { useState, useEffect,useContext } from 'react';
import { Box, Typography, IconButton, Button, useMediaQuery, useTheme } from '@mui/material'; 
import Grid from './ContainerGrid'; 
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import BaseFieldControl from "./BaseFieldControl"; 
import ManagedModal from './ManagedModal';
import AuthContext from "./auth/Context";

export default function FilterDrawer({
  open, 
  onClose, 
  filterFields, 
  currentData, 
  defaultData, 
  cancelLabel,
  searchLabel,
  onApply    
}) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  const context = useContext(AuthContext)

  // ================= 1. STATE NHÁP (DRAFT STATE) =================
  const [localData, setLocalData] = useState({});
  const [localErrors, setLocalErrors] = useState({});

   const evaluateCondition = (condition) => {
    if (!condition) return false;
    if (typeof condition === 'function') {
      try {
        //console.log("handle hideInForm",localData);
        return condition(context, localData);
      } catch (error) {
        console.warn("Lỗi chạy script điều kiện (hideInForm/hideInList):", error);
        return false; // Nếu script lỗi, mặc định hiển thị ra cho an toàn
      }
    }
    return !!condition;
  };

  useEffect(() => {
    if (open) {
      setLocalData(currentData || {});
      setLocalErrors({});
    }
  }, [open, currentData]);

  // ================= 2. XỬ LÝ SỰ KIỆN TẠI CHỖ =================
  const handleFilterChange = (field, val) => {
    //console.log("[reportfilter][handleFilterChange]",{field, val})
    setLocalData(prev => ({ ...prev, [field]: val }));
    if (localErrors[field]) {
      setLocalErrors(prev => ({ ...prev, [field]: null }));
    }
  };

  const handleReset = () => {
    setLocalData(defaultData || {});
    setLocalErrors({});
  };

  // ================= 3. BẮT LỖI TRƯỚC KHI GỬI ĐI =================
  const handleApplyClick = () => {
    const newErrors = {};
    let isValid = true;

    (filterFields || []).forEach(f => {
      if (f.required) {
        const val = localData[f.field];
        let isFieldEmpty = false;

        if (val === undefined || val === null || val === '') isFieldEmpty = true;
        else if (Array.isArray(val) && val.length === 0) isFieldEmpty = true;
        else if (f.type === 'DateFilter' && typeof val === 'object') {
          const fromKey = f.mapTo?.[0] || 'fromDate';
          const toKey = f.mapTo?.[1] || 'toDate';
          if (!val[fromKey] || !val[toKey]) isFieldEmpty = true;
        }

        if (isFieldEmpty) {
          isValid = false;
          newErrors[f.field] = f.errorMessage || `Vui lòng nhập ${f.label.toLowerCase()}`;
        }
      }
    });

    if (!isValid) {
      setLocalErrors(newErrors);
      return;
    }

    onApply(localData);
  };
  //console.log(filterFields);
  const currentFields =  filterFields.filter(f => !evaluateCondition(f.hideInForm));
  return (
    <ManagedModal
      type="drawer"
      anchor={isDesktop ? "right" : "bottom"} 
      open={open} 
      onClose={onClose}
      PaperProps={{ 
        sx: isDesktop 
          ? { width: 380, borderRadius: 3, m: 2, height: 'auto', maxHeight: 'calc(100vh - 32px)', display: 'flex', flexDirection: 'column', overflow: 'hidden', bgcolor: 'background.default' } 
          : { borderTopLeftRadius: 24, borderTopRightRadius: 24, pb: 'max(24px, env(safe-area-inset-bottom))', maxHeight: '85vh', width: '100%', display: 'flex', flexDirection: 'column', bgcolor: 'background.default' } 
      }}
    >
      {/* SỬA LỖI: Bỏ padding tổng, ép thẻ bao ngoài chiếm tối đa không gian và ẩn nội dung tràn (overflow: hidden) */}
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
          
          {/* KHU VỰC HEADER: Cố định (Không bị cuộn) */}
          <Box sx={{ p: 2, pb: 1, flexShrink: 0 }}>
            {!isDesktop && (<Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}><Box sx={{ width: 40, height: 4, bgcolor: 'divider', borderRadius: 2 }} /></Box>)}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6" fontWeight="bold" color="primary.main" sx={{ display: 'flex', alignItems: 'center' }}>
                <FilterListIcon sx={{ mr: 0.5 }} /> Điều kiện lọc
              </Typography>
              <IconButton onClick={onClose} size="small" sx={{ bgcolor: 'action.hover' }}>
                <CloseIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Box>
          </Box>
          
          {/* KHU VỰC BODY: Chứa form lọc, CÓ THANH CUỘN (Tự động lấp đầy phần trống giữa Header và Footer) */}
          <Box sx={{ p: 2, pt: 1, overflowY: 'auto', flexGrow: 1, minHeight: 0 }}>
            <Grid container spacing={2}>
              {currentFields.map(field => (
                <Grid size={field.gridFilter || { xs: 12, sm: 12, md: field.width || 12 }} key={field.field}>
                  <BaseFieldControl 
                    field={field} value={localData[field.field]} onChange={(val) => handleFilterChange(field.field, val)}
                    formData={localData} error={localErrors[field.field]}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
          
          {/* KHU VỰC FOOTER: Cố định dưới đáy (Không bị cuộn) */}
          <Box sx={{ p: 2, borderTop: '1px solid #f0f0f0', display: 'flex', gap: 1.5, flexShrink: 0, bgcolor: 'background.default' }}>
            <Button variant="outlined" color="inherit" fullWidth onClick={handleReset} sx={{ borderRadius: 2, textTransform: 'none' }}>
              Xóa lọc
            </Button>
            <Button variant="contained" color="primary" fullWidth startIcon={<SearchIcon />} onClick={handleApplyClick} sx={{ borderRadius: 2, textTransform: 'none' }}>
              {searchLabel || "Xem báo cáo"}
            </Button>
          </Box>

      </Box>
    </ManagedModal>
  );
}